import DataGridTableSkeleton from "../../../../components/skeletons/DataGridTableSkeleton";

export default function ProductCategoryListSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
